// Steps where the approver signs a PDF sourced from an earlier step and, on save, that
// signed file is uploaded and the step is approved in one action (no separate manual
// re-upload + Approve click). Add a step here to opt it into the same automated flow.
export const SIGN_AND_APPROVE_STEPS = {
  15: {
    sourceStepNumber: 12,
    sourceFieldKey: "loiForSigning",
    outputFieldKey: "executedLoi",
    outputDateFieldKey: "executedLoiDocumentDate",
    buttonLabel: "Sign & Approve",
    hideApproveButton: true,
  },
};

export const getSignAndApproveConfig = (stepNumber) => SIGN_AND_APPROVE_STEPS[stepNumber] || null;
